import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';
import { MachinesRoutingModule } from './machines.routing';
import { MachineListComponent } from './components/list/machines-list.component';
import { MachinesListPageComponent } from './pages/list/machines-list-page.component';
import { MachineDetailPageComponent } from './pages/detail/machine-detail-page.component';
import { CustomerMachinesPageComponent } from './pages/customer-list/customer-machines-page.component';
import { MachineFormComponent } from './components/form/machine-form.component';
import { NewMachinePageComponent } from './pages/new/new-machine-page.component';
import { EditMachinePageComponent } from './pages/edit/edit-machine-page.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, TranslateModule, MachinesRoutingModule],
  declarations: [
    MachineListComponent,
    MachinesListPageComponent,
    CustomerMachinesPageComponent,
    MachineDetailPageComponent,
    MachineFormComponent,
    NewMachinePageComponent,
    EditMachinePageComponent
  ]
})
export class MachinesModule {}
